import {Typography} from "@mui/material";
import ModalBase from "@/components/Modal/ModalBase.tsx";
import type {FeeRequest} from "@/types/FeeRequest.ts";

const StatusHistoryModal = ({
    show,
    handleClose,
    feeRequest,
}: {
    show: boolean;
    handleClose: () => void;
    feeRequest: FeeRequest | null;
}) => {
    return (
        <ModalBase
            show={show}
            title={"Fee Request Status History"}
            handleClose={handleClose}
            hideConfirmButton={true}
        >
            {feeRequest && feeRequest.approverNotes ? (
                <Typography variant={"body1"} style={{display: "inline", whiteSpace: "pre-line"}}>
                    {feeRequest.approverNotes.replace(/\r/g, "\n")}
                </Typography>
            ) : (
                <Typography variant={"body1"} sx={{fontStyle: "italic"}}>
                    No status history to display.
                </Typography>
            )}
        </ModalBase>
    );
};

export default StatusHistoryModal;
